module.exports = __webpack_public_path__ + "static/media/carousel-2.b86a581f.jpg";